/**
 * SKU统计卡片组件
 */
import React from 'react';
import { Row, Col } from 'antd';
import { TeamOutlined, ClockCircleOutlined, BarChartOutlined } from '@ant-design/icons';
import { StatsCard } from '../../../components/UI/Card/StatsCard';

interface SKUStatsProps {
    stats: { total: number; thisMonth: number; analyzed: number };
    loading: boolean;
}

export const SKUStats: React.FC<SKUStatsProps> = ({ stats, loading }) => {
    return (
        <Row gutter={[24, 24]} className="stats-row">
            <Col xs={24} sm={12} lg={8}>
                <StatsCard
                    title="总SKU数"
                    value={stats.total}
                    icon={<TeamOutlined />}
                    color="blue"
                    loading={loading}
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <StatsCard
                    title="本月新增"
                    value={stats.thisMonth}
                    icon={<ClockCircleOutlined />}
                    color="green"
                    loading={loading}
                    trend={
                        stats.thisMonth > 0
                            ? {
                                value: stats.thisMonth,
                                type: 'increase',
                                label: 'vs 上月',
                            }
                            : undefined
                    }
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <StatsCard
                    title="已分析"
                    value={stats.analyzed}
                    icon={<BarChartOutlined />}
                    color="purple"
                    loading={loading}
                />
            </Col>
        </Row>
    );
};
